var xP = require('../xP');

module.exports = {
  name: 'radio', base: '_option', prototype: {
    element_selector: 'input[type=radio]',

    disable: function (disabled) {
      disabled = !arguments.length || disabled;

      if (this.disabled !== disabled) {
        xP.controls.radio.base.disable.apply(this, arguments);

        if (disabled) {
          if (this.selected) {
            //xP.after(function(){
            this._.group.siblings.each(function () {
              if (!this.disabled) {
                this.select();

                return false;
              }
            });
            //});
          }
        } else if (
          this._.group.selected
          && this._.group.selected.disabled
        ) {
          this.select();

          this.change();
        }
      }
      return this;
    },

    select: function (selected, _onchange) {
      selected = !arguments.length || selected;

      if (this.selected !== selected) {
        if (selected && this._.group) {
          var that_selected = this._.group.selected;

          this._.group.selected = this;

          if (that_selected) {
            //xP.after(function(){
            that_selected.select(false);
            //});
          }
        }
        xP.controls.radio.base.select.apply(this, arguments);
      }

      return this;
    }
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/radio.js
 ** module id = 26
 ** module chunks = 0
 **/